import { useEffect, useMemo, useState } from 'react';
import { Circle, CircleMarker, MapContainer, Polygon, Popup, TileLayer, Tooltip, ZoomControl } from 'react-leaflet';
import { fetchPointControlsByYardApi, GetPerimeterYard, GetYardById } from '../../../services/api';
import { useAuth } from '../../../context/AuthContext';
import { colorMaps } from '../../../util/util';
import { Cargando } from '../../../components/Cargando';

export default function MapaBase({ assignment, children, pointControls }) {
  const { token } = useAuth();
  const [patio, setPatio] = useState(null);
  const [perimetro, setPerimetro] = useState([]);
  const [puntosControl, setPuntosControl] = useState([]);

  const shouldFetchPoints = useMemo(() => pointControls === undefined, [pointControls]);

  useEffect(() => {
    if (!shouldFetchPoints) {
      setPuntosControl(Array.isArray(pointControls) ? pointControls : []);
    }
  }, [shouldFetchPoints, pointControls]);

  useEffect(() => {
    const pintarMapaPatio = async () => {
      if (!assignment?.yardId) {
        setPatio(null);
        setPerimetro([]);
        if (shouldFetchPoints) setPuntosControl([]);
        return;
      }

      try {
        const [data, dataPerimetros] = await Promise.all([
          GetYardById({ token, yardId: assignment.yardId }),
          GetPerimeterYard({ yardId: assignment.yardId, token }),
        ]);

        setPatio(data);
        setPerimetro(
          (Array.isArray(dataPerimetros) ? dataPerimetros : [])
            .sort((a, b) => a.order - b.order)
            .map(p => [p.latitude, p.longitude])
        );

        if (shouldFetchPoints) {
          const dataPuntosControl = await fetchPointControlsByYardApi(assignment.yardId, { token });
          setPuntosControl(Array.isArray(dataPuntosControl) ? dataPuntosControl : []);
        }
      } catch (err) {
        console.error(err);
        setPatio(null);
        setPerimetro([]);
        if (shouldFetchPoints) setPuntosControl([]);
      }
    };

    pintarMapaPatio();
  }, [assignment?.yardId, token, shouldFetchPoints]);

  if (!patio?.latitude || !patio?.longitude) {
    return <Cargando />;
  }

  return (
    <MapContainer
      key={assignment?.yardId}
      center={[patio.latitude, patio.longitude]}
      zoom={18}
      maxZoom={23}
      zoomControl={false}
      style={{ height: '70vh', width: '100%' }}
    >
      <ZoomControl position="topright" />

      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      <Polygon
        positions={perimetro}
        pathOptions={{
          color: 'blue',
          weight: 2,
          fillOpacity: 0.1,
          fillColor: colorMaps.perimeterFill,
        }}
      />
      {puntosControl.map((pc, index) => (
        <Circle
          key={pc.id}
          center={[pc.latitude, pc.longitude]}
          radius={pc.geozoneRadio}
          pathOptions={{
            color: colorMaps.zoneStroke,
            fillOpacity: 0.15,
            weight: 2.5,
            fillColor: colorMaps.zoneFill,
          }}
        >
          <Popup>
            <div className='text-center'>
              <b>{pc.name}</b> <br />
              Radio: {pc.geozoneRadio}m <br />
              Lat: {pc.latitude} <br />
              Lng: {pc.longitude}
            </div>
          </Popup>
          <CircleMarker
            center={[pc.latitude, pc.longitude]}
            radius={5}
            pathOptions={{
              color: colorMaps.zoneCenter,
              weight: 2,
              fillOpacity: 1,
              fillColor: colorMaps.zoneCenter,
            }}
          />
          <Tooltip
            permanent
            interactive={false}
            direction="bottom"
            offset={[0, 12]}
            className="pc-label"
            opacity={1}
          >
            <p className='text-center fs-5 fw-semibold'>{pc.order}. {pc.name}</p>

          </Tooltip>
        </Circle>
      ))}
      {children}
    </MapContainer>
  );
}
